// DS: i7.16
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const NumberedList = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.504 16c.274 0 .496.222.496.496v.082a1 1 0 01-.293.707l-.207.207a.707.707 0 000 1l.207.207a1 1 0 01.293.707v.09a.504.504 0 01-.504.504H5.5a.5.5 0 110-1H7l-.293-.293a1 1 0 010-1.414L7 17H5.5a.5.5 0 110-1h2.004zM18 17a1 1 0 01.117 1.993L18 19h-7a1 1 0 01-.117-1.993L11 17h7zM7.504 10c.274 0 .496.222.496.496v.095a1 1 0 01-.278.691L6.078 13H7.5a.5.5 0 110 1h-2a.5.5 0 01-.5-.5v-.075a1 1 0 01.307-.72L7.078 11H5.5a.5.5 0 110-1h2.004zM18 11a1 1 0 01.117 1.993L18 13h-7a1 1 0 01-.117-1.993L11 11h7zM6 4a1 1 0 01.993.883L7 5v2.501a.5.5 0 01-.992.09L6 7.5V5h-.5a.5.5 0 01-.09-.992L5.5 4H6zm12 1a1 1 0 01.117 1.993L18 7h-7a1 1 0 01-.117-1.993L11 5h7z"
    })));
};
NumberedList.displayName = 'NumberedList';
export default NumberedList;
